"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _styles = require("@material-ui/core/styles");

var _Checkbox = _interopRequireDefault(require("@material-ui/core/Checkbox"));

var _core = require("@material-ui/core");

var _ViewColumn = _interopRequireDefault(require("@material-ui/icons/ViewColumn"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var useStyles = (0, _styles.makeStyles)(function (theme) {
  return {
    root: {
      width: "100%",
      maxWidth: 360 // backgroundColor: theme.palette.background.paper,

    },
    container: {
      display: "flex",
      maxHeight: "400px",
      overflowY: "scroll"
    },
    paper: {
      // border: "1px solid",
      padding: theme.spacing(1),
      backgroundColor: theme.palette.background.paper
    }
  };
});
/**
 * values adalah list kolom dengan minimal memiliki properti berikut
 * values: [
 *  { key: 1, title: 1, frozen: true, visible: true },
 *  { key: 2, title: 2, frozen: false, visible: false },
 *  ...
 * ]
 *
 * FROZEN:
 * checkbox checked ketika frozen == true
 * default frozen selain true akan dianggap false
 * onChange adalah fungsi yang dapat digunakan untuk mengubah state frozen pada values
 * onChange param:
 *  - array index of values
 *  - a value of values
 *
 * VISIBLE:
 * checkbox checked ketika visible != false
 * default visible selain false akan dianggap true/visible
 * onChange adalah fungsi yang dapat digunakan untuk mengubah state frozen pada values
 * onChange param:
 *  - array index of values
 *  - a value of values
 */

var ColumnList = function ColumnList(props) {
  var classes = useStyles();
  var values = props.values,
      onChange = props.onChange,
      onFrozenChange = props.onFrozenChange,
      onVisibilityChange = props.onVisibilityChange; // ----- Popper

  var _React$useState = _react["default"].useState(null),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      anchorEl = _React$useState2[0],
      setAnchorEl = _React$useState2[1];

  var open = Boolean(anchorEl);
  var id = open ? "simple-popper" : undefined;

  var handleClick = function handleClick(event) {
    setAnchorEl(anchorEl ? null : event.currentTarget);
  };

  var handleClickAway = function handleClickAway() {
    setAnchorEl(null);
  }; // -----/ Popper
  // ----- Filter checkbox


  var handleToggleFrozen = function handleToggleFrozen(i, value) {
    return function () {
      onFrozenChange(i, value);
    };
  };

  var handleToggleVisible = function handleToggleVisible(i, value) {
    return function () {
      onVisibilityChange(i, value);
    };
  };

  return /*#__PURE__*/_react["default"].createElement(_core.ClickAwayListener, {
    onClickAway: handleClickAway
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: classes.root
  }, /*#__PURE__*/_react["default"].createElement(_core.Tooltip, {
    title: "Column List"
  }, /*#__PURE__*/_react["default"].createElement(_core.IconButton // disableRipple
  , {
    onClick: handleClick,
    "aria-describedby": id // size="small"

  }, /*#__PURE__*/_react["default"].createElement(_ViewColumn["default"], {
    fontSize: "small"
  }))), /*#__PURE__*/_react["default"].createElement(_core.Popper, {
    id: id,
    open: open,
    anchorEl: anchorEl,
    placement: "bottom-start"
  }, /*#__PURE__*/_react["default"].createElement(_core.Paper, {
    className: classes.container
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: classes.paper
  }, /*#__PURE__*/_react["default"].createElement("div", null, "Freeze Columns"), /*#__PURE__*/_react["default"].createElement(_core.List, {
    className: classes.root
  }, values.map(function (value, i) {
    var labelId = "checkbox-list-label-".concat(value.key);
    return /*#__PURE__*/_react["default"].createElement(_core.ListItem, {
      key: value.key,
      role: undefined,
      dense: true,
      button: true,
      onClick: handleToggleFrozen(i, value)
    }, /*#__PURE__*/_react["default"].createElement(_core.ListItemIcon, null, /*#__PURE__*/_react["default"].createElement(_Checkbox["default"], {
      edge: "start",
      checked: values[i].frozen ? true : false,
      tabIndex: -1,
      disableRipple: true,
      inputProps: {
        "aria-labelledby": labelId
      }
    })), /*#__PURE__*/_react["default"].createElement(_core.ListItemText, {
      id: labelId,
      primary: "".concat(value.title)
    }));
  }))), /*#__PURE__*/_react["default"].createElement("div", {
    className: classes.paper
  }, /*#__PURE__*/_react["default"].createElement("div", null, "Visible Columns"), /*#__PURE__*/_react["default"].createElement(_core.List, {
    className: classes.root
  }, values.map(function (value, i) {
    var labelId = "checkbox-list-label-".concat(value.key);
    return /*#__PURE__*/_react["default"].createElement(_core.ListItem, {
      key: value.key,
      role: undefined,
      dense: true,
      button: true,
      onClick: handleToggleVisible(i, value)
    }, /*#__PURE__*/_react["default"].createElement(_core.ListItemIcon, null, /*#__PURE__*/_react["default"].createElement(_Checkbox["default"], {
      edge: "start",
      checked: values[i].visible !== false,
      tabIndex: -1,
      disableRipple: true,
      inputProps: {
        "aria-labelledby": labelId
      }
    })), /*#__PURE__*/_react["default"].createElement(_core.ListItemText, {
      id: labelId,
      primary: "".concat(value.title)
    }));
  })))))));
};

var _default = ColumnList;
exports["default"] = _default;